module.exports = __webpack_public_path__ + "static/media/table.c2748486.svg";